import { v4 as uuidv4 } from 'uuid';

const Message = function (mood, message) {
  this.id = uuidv4();
  this.mood = mood;
  this.message = message;
};

export default Message;